import {InformoLoader} from 'app/cities/informo/informo-loader.service';
import {INFORMO} from 'app/cities/informo/informo.module';

export const CITY_REGISTER = [
  {
    id: 'informo',
    loader: InformoLoader,
    metadata: INFORMO
  },
];



// WEBPACK FOOTER //
// ./src/app/cities/informo.loaders.ts